import React from "react";
import { ArrowRight, Check, Cpu, MemoryStick, HardDrive } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const builds = [{
  title: "Hospital Regional",
  description: "Modernização completa da infraestrutura tecnológica e implementação de sistemas da cadeia do frio",
  priceRange: "+30% Eficiência",
  image: "https://doctorice.10web.cloud/wp-content/uploads/2026/04/A-instituicao-hospitalar-e-referencia-em-oncologia-e-atende-38-municipios-da-regiao.jpg?v=og11sck0vf",
  specs: [{
    icon: Cpu,
    text: "Diagnóstico por Imagem"
  }, {
    icon: MemoryStick,
    text: "Gestão de Ativos Médicos"
  }, {
    icon: HardDrive,
    text: "Suporte Técnico 24/7"
  }],
  highlight: false
}, {
  title: "Clínica Premium",
  description: "Solução integrada de hardware e software para otimização do atendimento e experiência do paciente.",
  priceRange: "-20% Custos",
  image: "https://doctorice.10web.cloud/wp-content/uploads/2026/04/hospital_automation_eleven_processes.jpg?v=isqhprrl0qs",
  specs: [{
    icon: Cpu,
    text: "Integração Total de Dados"
  }, {
    icon: MemoryStick,
    text: "Treinamento de Equipes"
  }, {
    icon: HardDrive,
    text: "Manutenção Preventiva"
  }],
  highlight: true
}, {
  title: "Centro de Diagnóstico",
  description: "Fornecemos equipamentos de refrigeração para processo e conforto",
  priceRange: "100% Eficiência",
  image: "https://doctorice.10web.cloud/wp-content/uploads/2026/04/santa-emilia-rede-dor.jpg?v=lin4b6qlym",
  specs: [{
    icon: Cpu,
    text: "Prontuário em Nuvem"
  }, {
    icon: MemoryStick,
    text: "Segurança Avançada"
  }, {
    icon: HardDrive,
    text: "Rede de Alta Velocidade"
  }],
  highlight: false
}];
export default function EconomicIntermediateAdvancedBuilds() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="35743" id="cases-clientes" ref={ref} className="bg-background py-16 sm:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`mb-12 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-foreground text-3xl font-default font-bold tracking-tight sm:text-4xl md:text-5xl">
            Nossos Cases de Sucesso
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg font-sans">
            Conheça como a Doctorice transforma a gestão de clínicas e hospitais com tecnologia de ponta e equipamentos de alta performance.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3 lg:gap-10">
          {builds.map((build, index) => <div key={index} data-index={index} className={`flex transition-all duration-700 delay-${index * 150} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className={`flex h-full w-full flex-col overflow-hidden border transition-shadow hover:shadow-2xs ${build.highlight ? "border-primary/50 shadow-2xs ring-1 ring-primary/20" : "border-border"}`}>
                <div className="relative aspect-video w-full overflow-hidden bg-muted">
                  <img src={build.image} alt={build.title} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" loading="lazy" />
                  {build.highlight && <div className="bg-primary text-primary-foreground absolute top-3 right-3 rounded-full px-3 py-1 text-xs font-default font-medium shadow-2xs">
                      Destaque
                    </div>}
                </div>

                <CardHeader>
                  <CardTitle className="text-xl md:text-2xl font-default">{build.title}</CardTitle>
                  <CardDescription className="mt-2 text-base font-sans">
                    {build.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="flex-1">
                  <div className="mb-6">
                    <span className="text-muted-foreground text-sm font-sans font-medium uppercase tracking-wider">
                      Impacto Alcançado
                    </span>
                    <p className="text-primary mt-1 text-2xl font-default font-bold">
                      {build.priceRange}
                    </p>
                  </div>

                  <ul className="space-y-3">
                    {build.specs.map((spec, i) => <li key={i} data-index={i} className="flex items-center gap-3">
                        <div className="bg-secondary/50 flex h-8 w-8 shrink-0 items-center justify-center rounded-full">
                          <spec.icon className="text-primary h-4 w-4" />
                        </div>
                        <span className="text-foreground/80 text-sm font-sans">{spec.text}</span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter className="pt-4 pb-6">
                  <Button asChild className="w-full font-default" variant={build.highlight ? "default" : "outline"} size="lg">
                    <Link to="/SolutionsPage" aria-label={`Ver detalhes do case ${build.title}`}>
                      Ver Detalhes
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}